import React from 'react';
import { useHistory } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { Button, TableCell, TableRow } from '@insurancemenu/imenu-components-lib';
import { dateFormatters } from '@insurancemenu/imenu-components-lib/dist/helpers';
import { useRootStore } from 'store/rootStore';
import { checkIfCuttingOff } from 'global/utils/checkIfCuttingOff';
import { EnrollmentPeriod, Proposal } from 'types/enrollmentService';
import {
  getProductLinesFromArray,
  sortByProductLineId,
} from '@insurancemenu/imenu-components-lib/dist/utils/ProductLinesHelper';
import { createStyles } from './styles';

interface QuoteTableRowPropsType {
  proposal: Proposal;
  enrollmentPeriod: EnrollmentPeriod;
}

const QuoteTableRow = observer(({ proposal, enrollmentPeriod }: QuoteTableRowPropsType): JSX.Element => {
  const classes = createStyles();
  const history = useHistory();

  // Mobx store
  const { domainStoreV2 } = useRootStore();

  const sortedProductLineIds = proposal.productLines
    .sort((a, b) => {
      return sortByProductLineId(a.id, b.id);
    })
    .map((pLine) => pLine.id);

  const getCuttingOffLabel = (effectiveDate: string): JSX.Element | null => {
    const { cuttingOffInFortnight, cutOffInDays } = checkIfCuttingOff(
      effectiveDate,
      domainStoreV2.domainHeader.properties.retroActiveDaysAmount || 10,
    );
    if (cuttingOffInFortnight && cutOffInDays === 0) {
      return <p className={classes.expiredLabel}>Cut off</p>;
    }
    return null;
  };

  const redirectToProposalPage = (): void => {
    history.push(`/proposal-v2/${enrollmentPeriod.id}?cartId=${proposal.cartId}&groupId=${enrollmentPeriod.groupId}`);
  };

  return (
    <TableRow className={classes.tableRow}>
      <TableCell className={classes.tableCell} onClick={redirectToProposalPage}>
        {proposal.name}
      </TableCell>
      <TableCell className={classes.tableCell}>
        {dateFormatters.normDateToShortAmericanDate(enrollmentPeriod.effectiveDate)}
        {getCuttingOffLabel(enrollmentPeriod.effectiveDate)}
      </TableCell>
      <TableCell className={classes.tableCell}>{getProductLinesFromArray(sortedProductLineIds)}</TableCell>
      <TableCell className={classes.tableCell} onClick={redirectToProposalPage}>
        <Button color="primary">Continue</Button>
      </TableCell>
    </TableRow>
  );
});

export default QuoteTableRow;
